import React from 'react';
import { formatCurrency } from '../../utils';
import { List } from 'antd';
import { Wrapper, Header, Content, Footer } from './styles';

const Order = ({ order }) => {
    const orderTime = new Date(order.updatedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const { sales } = order

    const calculateTotal = () => {
        return sales.reduce((accum, currentSale) => {
            const { price, quantity } = currentSale;
            const totalAmount = Number(price / 100) * Number(quantity);
            return accum + totalAmount;
        }, 0);
    }
    return (
        <Wrapper key={order.id} >
            <Header>
                <div>#{order.orderNumber}</div>
                <div>TABLE - {order.tableNumber}</div>
                <div>{orderTime}</div>
            </Header>
            <Content>
                <List
                    size="small"
                    dataSource={sales}
                    renderItem={(item) => {
                        const { name, quantity } = item;
                        return <List.Item>{`${quantity} ${name.toUpperCase()}`}</List.Item>
                    }}
                />
            </Content>
            <Footer>
                <div>Paid</div>
                <div>{formatCurrency({
                    price: calculateTotal(),
                })}</div>

            </Footer>
        </Wrapper>
    );
};

export default Order;